export default __webpack_public_path__ + "static/media/logoBlack.c1e5e44f.png";